import { I_QREditorFormTemplate } from "@/data/types/pages";
import { PAGES } from "@/internals/constants/pages";
import { StatsFormFields } from "./stats-block";

const structure: I_QREditorFormTemplate = {
  page: PAGES.QR_VCARD,
  metaTitle: "meta_title",
  metaDescription: "meta_description",
  title: "title",
  formFields: [
    {
      component: "Accordion",
      title: "name_title",
      className: "qrForm",
      formFields: [
        {
          component: "InputLib",
          type: "text",
          placeholder: "name_placeholder",
          errorMessage: [{ rule: "maxLength", message: "name_maximum_length" }],
          name: "qrName",
          data_qa: "qr-vcard-name-input",
        },
      ],
    },
    {
      component: "Accordion",
      title: "theme_picker_title",
      formFields: [
        {
          component: "ThemePicker",
          labelPrimary: "theme_picker_label_primary",
          labelSecondary: "theme_picker_label_secondary",
          id: "qrVcardThemePicker",
          name: "themeColor",
          data_qa: "qr-vcard-theme-picker",
        },
      ],
    },
    {
      component: "Accordion",
      title: "information_title",
      id: "qrVcardInformation",
      className: "qrvcardInformation",
      formFields: [
        {
          component: "div",
          className: "u-flex-full",
          formFields: [
            {
              component: "ImageUpload",
              title: "image_title",
              id: "qrVcardImage",
              showEditor: "profile",
              name: "logoUrl",
              data_qa: "qr-vcard-image-upload",
            },
          ],
        },

        {
          component: "div",
          className: "fullName-wrapper",
          formFields: [
            {
              component: "InputLib",
              type: "text",
              label: "full_Name",
              placeholder: "full_name_placeholder",
              errorMessage: [
                { rule: "required", message: "required_message" },
                {
                  rule: "maxLength",
                  message: "full_name_max_length",
                },
              ],
              name: "fullName",
              data_qa: "qr-vcard-fullName-input",
            },
            {
              component: "InputLib",
              type: "text",
              label: "email",
              placeholder: "email_placeholderr",
              errorMessage: [{ rule: "pattern", message: "invalid_email" }],
              name: "email",
              data_qa: "qr-vcard-email-input",
            },
          ],
        },

        {
          component: "div",
          className: "contact-phone",
          formFields: [
            {
              component: "InputLib",
              type: "text",
              label: "mobile_phone",
              placeholder: "mobile_phone_placeholder",
              name: "mobilePhone",
              data_qa: "qr-vcard-mobile-phone-input",
            },
            {
              component: "InputLib",
              type: "text",
              label: "landline_phone",
              placeholder: "landline_phone_placeholder",
              name: "landlinePhone",
              data_qa: "qr-vcard-landline-phone-input",
            },

            {
              component: "InputLib",
              type: "text",
              label: "fax_phone",
              placeholder: "fax_phone_placeholder",
              name: "fax",
              data_qa: "qr-vcard-fax-input",
            },
          ],
        },

        {
          component: "div",
          className: "job-info",
          formFields: [
            {
              component: "InputLib",
              type: "text",
              label: "website",
              placeholder: "website_placeholder",
              name: "website",
              errorMessage: [{ rule: "pattern", message: "invalid_link" }],
              data_qa: "qr-vcard-website-input",
            },
            {
              component: "InputLib",
              type: "text",
              label: "company",
              placeholder: "company_placeholder",
              name: "companyName",
              data_qa: "qr-vcard-company-name-input",
            },

            {
              component: "InputLib",
              type: "text",
              label: "profession",
              placeholder: "profession_placeholder",
              name: "profession",
              data_qa: "qr-vcard-profession-input",
            },
          ],
        },

        {
          component: "TextAreaLib",
          resize: "none",
          label: "summary",
          placeholder: "summary_placeholder",
          errorMessage: [
            {
              rule: "maxLength",
              message: "summary_maximum_length",
            },
          ],
          name: "summary",
          data_qa: "qr-vcard-sumary-input",
        },
      ],
    },
    {
      component: "Accordion",
      title: "location_title",
      className: "location",
      formFields: [
        {
          component: "div",
          className: "address-numeration-wrapper",
          formFields: [
            {
              component: "InputLib",
              type: "text",
              label: "address_label",
              placeholder: "address_placeholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "address_maximum_length",
                },
              ],
              name: "address",
              data_qa: "qr-vcard-address-input",
            },
            {
              component: "div",
              className: "numeration-wrapper",
              formFields: [
                {
                  component: "InputLib",
                  type: "text",
                  label: "numeration_label",
                  placeholder: "numeration_placeholder",
                  errorMessage: [
                    {
                      rule: "maxLength",
                      message: "numeration_maximum_length",
                    },
                  ],
                  name: "numeration",
                  data_qa: "qr-vcard-numeration-input",
                },
                {
                  component: "InputLib",
                  type: "text",
                  label: "zip_code_label",
                  placeholder: "zip_code_placeholder",
                  errorMessage: [
                    {
                      rule: "maxLength",
                      message: "zip_code_maximum_length",
                    },
                  ],
                  name: "zipCode",
                  data_qa: "qr-vcard-zip-code-input",
                },
              ],
            },
          ],
        },
        {
          component: "div",
          className: "address-state",
          formFields: [
            {
              component: "InputLib",
              type: "text",
              label: "city_label",
              placeholder: "city_placeholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "city_maximum_length",
                },
              ],
              name: "city",
              data_qa: "qr-vcard-city-input",
            },
            {
              component: "InputLib",
              type: "text",
              label: "state_label",
              placeholder: "state_placeholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "state_maximum_length",
                },
              ],
              name: "state",
              data_qa: "qr-vcard-state-input",
            },
            {
              component: "InputLib",
              type: "text",
              label: "country_label",
              placeholder: "country_placeholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "country_maximum_length",
                },
              ],
              name: "country",
              data_qa: "qr-vcard-country-input",
            },
          ],
        },
      ],
    },

    {
      component: "Accordion",
      title: "socials_title",
      formFields: [
        {
          component: "ListPicker",
          id: "qrVcardSocials",
          title: "socials_title_multiple",
          titleEmpty: "socials_title_empty",
          name: "socialNetworks",
          data_qa: "qr-vcard-socials-list-picker",
          options: [
            {
              id: "facebook",
              name: "Facebook",
              value: "",
              data_qa: "facebook-button",
              placeholder: "https://facebook.com/profile",
              tooltip: { text: "Facebook", position: "top" },
            },
            {
              id: "instagram",
              name: "Instagram",
              value: "",
              data_qa: "instagram-button",
              placeholder: "https://instagram.com/profile",
              tooltip: { text: "Instagram", position: "top" },
            },
            {
              id: "threads",
              name: "Threads",
              value: "",
              data_qa: "threads-button",
              placeholder: "https://threads.com/profile",
              tooltip: { text: "Threads", position: "top" },
            },
            {
              id: "tiktok",
              name: "Tiktok",
              value: "",
              data_qa: "tiktok-button",
              placeholder: "https://tiktok.com/profile",
              tooltip: { text: "Tiktok", position: "top" },
            },
            {
              id: "x",
              name: "X",
              value: "",
              data_qa: "x-button",
              placeholder: "https://x.com/profile",
              tooltip: { text: "X", position: "top" },
            },
            {
              id: "reddit",
              name: "Reddit",
              value: "",
              data_qa: "reddit-button",
              placeholder: "https://reddit.com/profile",
              tooltip: { text: "Reddit", position: "top" },
            },
            {
              id: "nextdoor",
              name: "Nextdoor",
              value: "",
              data_qa: "nextdoor-button",
              placeholder: "https://nextdoor.com/profile",
              tooltip: { text: "Nextdoor", position: "top" },
            },
            {
              id: "tumblr",
              name: "Tumblr",
              value: "",
              data_qa: "tumblr-button",
              placeholder: "https://tumblr.com/profile",
              tooltip: { text: "Tumblr", position: "top" },
            },
            {
              id: "behance",
              name: "Behance",
              value: "",
              data_qa: "behance-button",
              placeholder: "https://behance.net/profile",
              tooltip: { text: "Behance", position: "top" },
            },
            {
              id: "bluesky",
              name: "Bluesky",
              value: "",
              data_qa: "bluesky-button",
              placeholder: "https://blueskyweb.xyz/profile",
              tooltip: { text: "Bluesky", position: "top" },
            },
            {
              id: "mastodon",
              name: "Mastodon",
              value: "",
              data_qa: "mastodon-button",
              placeholder: "https://mastodon.social/profile",
              tooltip: { text: "Mastodon", position: "top" },
            },
            {
              id: "vkontakte",
              name: "Vkontakte",
              value: "",
              data_qa: "vkontakte-button",
              placeholder: "https://vk.com/profile",
              tooltip: { text: "Vkontakte", position: "top" },
            },
            {
              id: "facebookMessenger",
              name: "Messenger",
              value: "",
              data_qa: "facebook-messenger-button",
              placeholder: "https://m.me/profile",
              tooltip: { text: "Messenger", position: "top" },
            },
            {
              id: "whatsapp",
              name: "WhatsApp",
              value: "",
              data_qa: "whatsapp-button",
              placeholder: "https://wa.me/1234567890",
              tooltip: { text: "WhatsApp", position: "top" },
            },
            {
              id: "microsoftTeams",
              name: "Microsoft Teams",
              value: "",
              data_qa: "microsoft-teams-button",
              placeholder: "https://teams.microsoft.com/l/profile",
              tooltip: { text: "Microsoft Teams", position: "top" },
            },
            {
              id: "discord",
              name: "Discord",
              value: "",
              data_qa: "discord-button",
              placeholder: "https://discord.com/invite/code",
              tooltip: { text: "Discord", position: "top" },
            },
            {
              id: "skype",
              name: "Skype",
              value: "",
              data_qa: "skype-button",
              placeholder: "https://skype.com/profile",
              tooltip: { text: "Skype", position: "top" },
            },
            {
              id: "telegram",
              name: "Telegram",
              value: "",
              data_qa: "telegram-button",
              placeholder: "https://t.me/profile",
              tooltip: { text: "Telegram", position: "top" },
            },
            {
              id: "line",
              name: "Line",
              value: "",
              data_qa: "line-button",
              placeholder: "https://line.me/profile",
              tooltip: { text: "Line", position: "top" },
            },
            {
              id: "snapchat",
              name: "Snapchat",
              value: "",
              data_qa: "snapchat-button",
              placeholder: "https://snapchat.com/profile",
              tooltip: { text: "Snapchat", position: "top" },
            },
            {
              id: "youtube",
              name: "YouTube",
              value: "",
              data_qa: "youtube-button",
              placeholder: "https://youtube.com/profile",
              tooltip: { text: "YouTube", position: "top" },
            },
            {
              id: "spotify",
              name: "Spotify",
              value: "",
              data_qa: "spotify-button",
              placeholder: "https://spotify.com/profile",
              tooltip: { text: "Spotify", position: "top" },
            },
            {
              id: "appleMusic",
              name: "Apple Music",
              value: "",
              data_qa: "apple-music-button",
              placeholder: "https://music.apple.com/profile",
              tooltip: { text: "Apple Music", position: "top" },
            },
            {
              id: "twitch",
              name: "Twitch",
              value: "",
              data_qa: "twitch-button",
              placeholder: "https://twitch.tv/profile",
              tooltip: { text: "Twitch", position: "top" },
            },
            {
              id: "soundcloud",
              name: "SoundCloud",
              value: "",
              data_qa: "soundcloud-button",
              placeholder: "https://soundcloud.com/profile",
              tooltip: { text: "SoundCloud", position: "top" },
            },
            {
              id: "vimeo",
              name: "Vimeo",
              value: "",
              data_qa: "vimeo-button",
              placeholder: "https://vimeo.com/profile",
              tooltip: { text: "Vimeo", position: "top" },
            },
            {
              id: "onlyfans",
              name: "OnlyFans",
              value: "",
              data_qa: "onlyfans-button",
              placeholder: "https://onlyfans.com/profile",
              tooltip: { text: "OnlyFans", position: "top" },
            },
            {
              id: "flickr",
              name: "Flickr",
              value: "",
              data_qa: "flickr-button",
              placeholder: "https://flickr.com/profile",
              tooltip: { text: "Flickr", position: "top" },
            },
            {
              id: "dribbble",
              name: "Dribbble",
              value: "",
              data_qa: "dribbble-button",
              placeholder: "https://dribbble.com/profile",
              tooltip: { text: "Dribbble", position: "top" },
            },
            {
              id: "pinterest",
              name: "Pinterest",
              value: "",
              data_qa: "pinterest-button",
              placeholder: "https://pinterest.com/profile",
              tooltip: { text: "Pinterest", position: "top" },
            },
            {
              id: "linkedin",
              name: "Linkedin",
              value: "",
              data_qa: "linkedin-button",
              placeholder: "https://linkedin.com/profile",
              tooltip: { text: "Linkedin", position: "top" },
            },
            {
              id: "github",
              name: "Github",
              value: "",
              data_qa: "github-button",
              placeholder: "https://github.com/profile",
              tooltip: { text: "Github", position: "top" },
            },
            {
              id: "quora",
              name: "Quora",
              value: "",
              data_qa: "quora-button",
              placeholder: "https://quora.com/profile",
              tooltip: { text: "Quora", position: "top" },
            },
            {
              id: "xing",
              name: "Xing",
              value: "",
              data_qa: "xing-button",
              placeholder: "https://xing.com/profile",
              tooltip: { text: "Xing", position: "top" },
            },
            {
              id: "googleReviews",
              name: "Google Reviews",
              value: "",
              data_qa: "google-reviews-button",
              placeholder: "https://business.google.com/profile",
              tooltip: { text: "Google Reviews", position: "top" },
            },
            {
              id: "yelp",
              name: "Yelp",
              value: "",
              data_qa: "yelp-button",
              placeholder: "https://yelp.com/profile",
              tooltip: { text: "Yelp", position: "top" },
            },
            {
              id: "tripadvisor",
              name: "Tripadvisor",
              value: "",
              data_qa: "tripadvisor-button",
              placeholder: "https://tripadvisor.com/profile",
              tooltip: { text: "Tripadvisor", position: "top" },
            },
            {
              id: "uberEats",
              name: "Uber Eats",
              value: "",
              data_qa: "uber-eats-button",
              placeholder: "https://ubereats.com/profile",
              tooltip: { text: "Uber Eats", position: "top" },
            },
            {
              id: "web",
              name: "Web",
              value: "",
              data_qa: "web-button",
              placeholder: "https://web.com/profile",
              tooltip: { text: "Web", position: "top" },
            },
          ],
        },
      ],
    },
    {
      component: "Accordion",
      title: "stats_title",
      subtitle: "stats_subtitle",
      className: "qrForm",
      formFields: StatsFormFields(),
    },
  ],
  layoutTranslations: {
    vcardPreviewEmail: "preview_email",
    vcardPreviewPhone: "preview_phone",
    vcardPreviewPhoneAlt: "preview_phone_alt",
    vcardPreviewFaxPhone: "preview_fax_phone",
    vcardPreviewWebsite: "preview_website",
    vcardPreviewCompany: "preview_company",
    vcardPreviewProfession: "preview_profession",
    vcardPreviewAddButton: "preview_add_button",
  },
};

export default structure;
